export const SESSION_EXPIRED_ERR = 'SessionExpired'
export const INVALID_ACCESS_TOKEN = 'InvalidAccessToken'
